import PropTypes from 'prop-types';
import { useCallback } from 'react';
import clsx from 'clsx';
import { DatagridBody, DatagridRow, useDatagridContext, useExpanded, useResourceContext } from 'react-admin';
import { hasSelectedText } from '@/helpers/ui/hasSelectedText.js';

export const CustomDatagridRow = ({ selected, className, id, rowClick, onClickCapture, ...rest }) => {
    const resource = useResourceContext();
    const { expandSingle } = useDatagridContext();
    const [expanded] = useExpanded(resource, id, expandSingle);

    const handleRowClick = useCallback(
        (recordId, resourceName, record) => {
            if (typeof rowClick === 'function') {
                return rowClick(recordId, resourceName, record);
            }

            return rowClick;
        },
        [rowClick],
    );

    const handleClickCapture = event => {
        if (hasSelectedText(event.currentTarget)) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        onClickCapture?.(event);
    };

    return (
        <DatagridRow
            {...rest}
            id={id}
            selected={selected}
            className={clsx(className, selected && 'checked', expanded && 'active')}
            rowClick={typeof rowClick === 'function' ? handleRowClick : rowClick}
            onClickCapture={handleClickCapture}
        />
    );
};

CustomDatagridRow.propTypes = {
    selected: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.any,
    rowClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.bool]),
    onClickCapture: PropTypes.func,
};

const defaultRow = <CustomDatagridRow />;

export const CustomDatagridBody = props => <DatagridBody {...props} row={defaultRow} />;
